import { render, staticRenderFns } from "./ArticleBodyBottomEasyRead.vue?vue&type=template&id=09a1c36e&scoped=true"
import script from "./ArticleBodyBottomEasyRead.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyBottomEasyRead.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyBottomEasyRead.vue?vue&type=style&index=0&id=09a1c36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1c36e",
  null
  
)

export default component.exports